import { ApiServiceV1 } from './api.service';

export const LocationsApiService = {
  async getLocations() {
    const { data } = await ApiServiceV1.get('location');
    return data || [];
  },
};

export default LocationsApiService;
